export enum OfferStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
}
